<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <span style="width: 100%;display: flex;justify-content: left;padding: 10px 0px;margin-left: 20px;">
            <span style="width: 63px; background-color: #589ff9;cursor: pointer;border-radius: 5px;margin-left: 15px;"
              @click="activeEvt(1)">
              <img src="../../../images/increase.png" style="width: 15px; height: 15px" alt="" />
            </span>
          </span>
          <el-table :data="tableData" border style="width: 821px;margin-left: 15px;" @cell-click="idEvt">
            <el-table-column fixed prop="name" label="货币名称" width="200"></el-table-column>
            <el-table-column prop="identification" label="货币标识" width="200"></el-table-column>
            <el-table-column prop="exchange_rate" label="汇率" width="200"></el-table-column>
            <el-table-column prop="is_active" label="是否有效" width="120">
              <template slot-scope="props">
                <span v-if="props.row.is_active === 1">有效</span>
                <span v-else-if="props.row.is_active === 2">无效</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="props">
                <el-button type="text" size="small" @click="activeEvt(2)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-main>
    <el-dialog title="银行账户" :visible.sync="dialogFormVisible" width="500px" :before-close="handleClose">
      <el-form>
        <el-form-item label="货币名称" :label-width="formLabelWidth">
          <el-input v-model="name" autocomplete="off" placeholder="请填写(必填项)" @focus="onInputFocus"
            @blur="onInputBlur"></el-input>
        </el-form-item>
        <el-form-item label="货币标识" :label-width="formLabelWidth">
          <el-input v-model="identification" autocomplete="off" placeholder="请填写" @focus="onInputFocus"
            @blur="onInputBlur"></el-input>
        </el-form-item>
        <el-form-item label="汇率" :label-width="formLabelWidth">
          <el-input v-model="exchange_rate" autocomplete="off" placeholder="请填写" @input="validateInput"
            @focus="onInputFocus" @blur="onInputBlur"></el-input>
        </el-form-item>
        <el-form-item label="是否有效" :label-width="formLabelWidth">
          <el-radio-group v-model="radio">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="2">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleBet">取 消</el-button>
        <el-button type="primary" @click="handle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPCurrencyApi, ERPSavecurrencyApi } from "@/api/bank/Account_details.js"

export default {
  components: {
    GlobalHeader
  },
  data() {
    return {
      activeIndex: "8-4",
      dialogVisible: false,
      radio: 1,
      name: '',
      identification: null,
      exchange_rate: null,
      selectedId: null,
      tableData: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      inputFocused: false, // 当前输入框是否有焦点
      inputEverFocused: false // 输入框是否曾经获得过焦点
    };
  },
  created() {
    ERPCurrencyApi().then((res) => {
      this.tableData = res.data
    })
  },
  methods: {
    handle() {
      if (!this.name || !this.exchange_rate || !this.identification) {
        this.$message.error('请输入内容');
        return
      }
      const params = {
        name: this.name,
        is_active: this.radio,
        exchange_rate: this.exchange_rate,
        identification: this.identification,
      };
      if (this.selectedId) {
        params.id = this.selectedId;
      }
      ERPSavecurrencyApi(params).then((res) => {
        if (res.code == 1000) {
          this.name = '';
          this.radio = 1;
          this.exchange_rate = '';
          this.identification = '';
          this.dialogFormVisible = false;
          this.getList()
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success'
          });
        } else {
          this.$message.error(res.msg)
        }
      });
    },
    handleClose(done) {
      if (this.inputFocused) {
        // 如果输入框有焦点，则阻止对话框关闭
        this.inputFocused = false; // 取消焦点
        return;
      }
      if (this.inputEverFocused) {
        // 如果输入框曾经获得过焦点，则需要再次点击才能关闭对话框
        this.inputEverFocused = false; // 重置状态
        return;
      }
      done(); // 否则，允许关闭对话框
    },
    handleBet() {
      this.name = '';
      this.radio = 1;
      this.selectedId = null;
      this.exchange_rate = '';
      this.identification = '';
      this.dialogFormVisible = false;
      this.inputEverFocused = false; // 重置状态
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.id;
      this.name = row.name;
      this.radio = row.is_active;
      this.exchange_rate = row.exchange_rate;
      this.identification = row.identification;
    },
    activeEvt(value) {
      if (value == 1) {
        // 新增操作
        this.name = '';
        this.radio = 1;
        this.exchange_rate = '';
        this.identification = '';
      } else if (value == 2) {
        // 编辑操作
        const selectedId = this.selectedId;
        this.name = this.name;
        this.radio = this.is_active;
        this.exchange_rate = this.exchange_rate;
        this.identification = this.identification;
      }
      this.dialogFormVisible = true;
      this.inputEverFocused = false; // 重置状态
    },
    validateInput() {
      // 使用正则表达式匹配整数和浮点数
      const regex = /^[+-]?\d*\.?\d*$/;
      if (!regex.test(this.exchange_rate)) {
        // 如果输入不符合要求，则清空输入框
        this.exchange_rate = '';
      }
    },
    onInputFocus() {
      console.log(2222);
      this.inputFocused = true; // 当输入框获得焦点时设置为true
      this.inputEverFocused = true; // 记录输入框曾经获得过焦点
    },
    onInputBlur() {
      console.log(111);
      this.inputFocused = false; // 当输入框失去焦点时设置为false
    },
    getList() {
      ERPCurrencyApi().then((res) => {
        this.tableData = res.data
      })
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  left: 175px;
  padding: 0px;
  top: 60px;
  position: relative;
}

.edit {}

/deep/.el-table .el-table__cell {
  padding: 9px 0;
}

/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/src/Bank_management/monetary_management/index.vue